import { render, staticRenderFns } from "./AddCustomerBasicInfo.vue?vue&type=template&id=3f68779e"
import script from "./AddCustomerBasicInfo.vue?vue&type=script&lang=js"
export * from "./AddCustomerBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports